export default __webpack_public_path__ + "static/media/sql.6e42b2a0.png";